<template>
  <!-- 主要显示的内容 -->
  <yxtf-tooltip placement="top" open-filter :class="[fromHor ? 'ellipsis-2' : 'ellipsis']">
    <div slot="content" :style="{ 'max-width': rankWidth + 'px' }">
      <content-name :code="code" :name="name" />
    </div>
    <content-name
      class="lh22 text-26 word-break"
      :class="{'block': !fromHor}"
      :code="code"
      :name="name"
    />
  </yxtf-tooltip>
</template>
<script>
import contentName from './contentName.vue';

export default {
  components: {
    contentName
  },
  props: {
    // 类型
    code: {
      type: String,
      default: ''
    },
    // 名称
    name: {
      type: String,
      default: ''
    },
    // 来自横排式的前三名
    fromHor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rankWidth: 0
    };
  },
  mounted() {
    this.rankWidth = this.$parent.$el.clientWidth * 0.7;
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
